{
  "dashboardTitle": "Notificări",
  "dashboardSubtitle": "Monitorizează statusul livrării emailurilor și SMS-urilor",
  "allEmails": "Toate Emailurile",
  "allSms": "Toate SMS-urile",
  "emailPending": "Emailuri în Așteptare",
  "smsPending": "SMS-uri în Așteptare",
  "failedToday": "Eșuate Azi",
  "deliveredToday": "Livrate Azi",
  "recentEmails": "Emailuri Recente",
  "recentSms": "SMS-uri Recente",
  "viewAll": "Vezi Toate",
  "viewDetail": "Vezi Detaliu",
  "noRecentEmails": "Nu există emailuri recente",
  "noRecentSms": "Nu există mesaje SMS recente",
  "loading": "Se încarcă...",
  "breadCrumbs": {
    "notifications": "Notificări"
  }
}
